export const animationDuration = {
  oneSecond: 1,
  twoSeconds: 2,
};
